import React from "react";
import { Modal } from "react-bootstrap";

const EditReportModal = ({
  show,
  onHide,
  formData,
  isUpdating,
  isRunNow,
  onChange,
  onSubmit,
}) => (
  <Modal show={show} onHide={onHide} size="lg" centered>
    <Modal.Header closeButton>
      <Modal.Title>Edit Scheduled Report</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={onSubmit}>
        <div className="row g-3">
          <div className="col-md-6">
            <label htmlFor="edit_campaign_id" className="form-label">
              Campaign ID
            </label>
            <input
              id="edit_campaign_id"
              type="text"
              className="form-control"
              value={formData.campaign_id}
              onChange={onChange("campaign_id")}
              disabled={isUpdating}
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="edit_report_name" className="form-label">
              Report Name
            </label>
            <input
              id="edit_report_name"
              type="text"
              className="form-control"
              value={formData.report_name}
              onChange={onChange("report_name")}
              disabled={isUpdating}
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="edit_recipients" className="form-label">
              Recipients
            </label>
            <input
              id="edit_recipients"
              type="text"
              className="form-control"
              value={formData.recipients}
              onChange={onChange("recipients")}
              disabled={isUpdating}
            />
          </div>

          {!isRunNow && (
            <>
              <div className="col-md-6">
                <label htmlFor="edit_start_date" className="form-label">
                  Start Date
                </label>
                <input
                  id="edit_start_date"
                  type="date"
                  className="form-control"
                  value={formData.start_date}
                  onChange={onChange("start_date")}
                  disabled={isUpdating}
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="edit_end_date" className="form-label">
                  End Date
                </label>
                <input
                  id="edit_end_date"
                  type="date"
                  className="form-control"
                  value={formData.end_date}
                  onChange={onChange("end_date")}
                  disabled={isUpdating}
                />
              </div>
            </>
          )}

          {!isRunNow && (
            <div className="col-md-4">
              <label htmlFor="edit_execution_time" className="form-label">
                Execution Hour (UTC)
              </label>
              <input
                id="edit_execution_time"
                type="number"
                min="0"
                max="23"
                step="1"
                className="form-control"
                value={formData.execution_time}
                onChange={onChange("execution_time")}
                disabled={isUpdating}
                placeholder="0-23"
                style={{ maxWidth: "110px" }}
              />
            </div>
          )}

          <div className="col-md-6">
            <label htmlFor="edit_frequency" className="form-label">
              Frequency
            </label>
            <select
              id="edit_frequency"
              className="form-select"
              value={formData.frequency}
              onChange={onChange("frequency")}
              disabled={isUpdating}
            >
              <option value="DAILY">DAILY</option>
              <option value="RUN NOW">RUN NOW</option>
            </select>
          </div>

          {!isRunNow && (
            <div className="col-md-6 d-flex align-items-end">
              <div className="form-check mb-2">
                <input
                  id="edit_only_form_data"
                  type="checkbox"
                  className="form-check-input"
                  checked={Boolean(formData.only_form_data)}
                  onChange={onChange("only_form_data")}
                  disabled={isUpdating}
                />
                <label htmlFor="edit_only_form_data" className="form-check-label">
                  Only Form Data
                </label>
              </div>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button type="button" className="btn btn-outline-secondary" onClick={onHide} disabled={isUpdating}>
            Cancel
          </button>
          <button type="submit" className="btn btn-primary" disabled={isUpdating}>
            {isUpdating ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </Modal.Body>
  </Modal>
);

export default EditReportModal;
